export var ResultFieldFormat;
(function (ResultFieldFormat) {
    ResultFieldFormat["dateTime"] = "date-time";
    ResultFieldFormat["input"] = "input";
    ResultFieldFormat["select"] = "select";
})(ResultFieldFormat || (ResultFieldFormat = {}));
